export default __webpack_public_path__ + "static/media/withdrawalPop.a9abb9cf.png";